<template>
  <div class="graph-holder">
    <div
      class="text-sm weight-600 title mb-4 hidden xl:block text-center"
      data-test="title"
    >
      AT A GLANCE
    </div>
    <div class="tabs-holder rounded-xl bg-white w-full shadow-md">
      <div class="tabs flex justify-center mb-5 p-3 flex-wrap w-full">
        <div
          class="tab cursor-pointer m-3 text-xl weight-600"
          :class="{ active: selectedTab === 'areaOfFocus' }"
          @click="selectTab('areaOfFocus')"
          data-test="tab-areaOfFocus"
        >
          Areas of Focus
        </div>
        <div
          class="tab cursor-pointer m-3 text-xl weight-600"
          :class="{ active: selectedTab === 'organizations' }"
          @click="selectTab('organizations')"
          data-test="tab-organizations"
        >
          Organizations
        </div>
      </div>
      <div class="tabs-holder">
        <PieChart
          v-if="selectedTab === 'areaOfFocus' && Object.keys(categoryData).length > 0 && organizationAmountsTotal > 0"
          :data="categoryData"
          :subheader="['cause', 'causes']"
          data-test="chart-areaOfFocus"
        ></PieChart>
        <PieChart
          v-else-if="
            selectedTab === 'organizations' && Object.keys(organizationData).length > 0 && organizationAmountsTotal > 0
          "
          :data="organizationData"
          :subheader="['donation', 'donations']"
          data-test="chart-organizations"
        ></PieChart>
        <div
          v-else
          class="w-[340px] mx-auto pb-16 text-center"
          data-test="no-data-message"
        >
          As you donate to organizations participating in our Gives Day, check back here for statistics on your giving
          behavior!
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
import { ref } from 'vue';
import PieChart from './PieChart.vue';
import { useDonorStore } from '@/stores/DonorStore.js';

const selectedTab = ref('areaOfFocus');
const donorStore = useDonorStore();
const mainColor = donorStore.mainColor;

const categoryData = useDonorStore().categoryAmounts;
const organizationData = useDonorStore().organizationAmounts;
const organizationAmountsTotal = useDonorStore().staticTotalAmountDonated;

function selectTab(tab) {
  selectedTab.value = tab;
}
</script>
<style>
.tab:hover {
  padding-bottom: 5px;
  border-bottom: 3px solid;
  border-bottom-color: var(--p-primary-500);
  margin-bottom: 20px;
}
.tab.active {
  padding-bottom: 5px;
  border-bottom: 3px solid;
  border-bottom-color: var(--p-primary-500);
  margin-bottom: 20px;
}
.graph-holder {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.graph-legend {
  display: flex;
  justify-content: space-between;
  margin: 0 auto;
  max-width: 100%;
  padding: 0 32px 40px 32px;
  align-items: center;
}
.pie-chart {
  width: 273px !important;
  height: 273px !important;
}
.legend {
  font-size: 16px;
  display: flex;
  flex-direction: column;
  width: 150px;
  margin-left: 20px;
}

.legend-row {
  line-height: 1.2em;
  margin-bottom: 16px;
  vertical-align: middle;
  display: flex;
  align-items: flex-start;
}

.legend-col {
  display: inline;
}

.legend-color {
  border-radius: 2px;
  display: block;
  float: left;
  height: 13px;
  margin-right: 8px;
  margin-top: 5px;
  width: 13px;
}

.legend-count {
  font-weight: bold;
}

.legend-label {
  color: #12274b;
  font-size: 14px;
  font-weight: 600;
  width: 120px;
}

.legend-label-subheader {
  color: #12274b;
  font-size: 12px;
  font-weight: 400;
}

@media screen and (max-width: 1300px) {
  .graph-holder {
    width: 100%;
  }
  .tabs-holder {
    width: 100%;
  }
  .graph-legend {
    display: flex;
    justify-content: space-around;
    flex-wrap: wrap;
  }
}
</style>
